export class FormSchoolGradeNotFoundError extends Error {
  constructor(message: string, readonly cause?: Error) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class OfferError extends Error {
  constructor(message: string, readonly cause?: Error) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class WaitlistError extends Error {
  constructor(message: string, readonly cause?: Error) {
    super(message);
    this.name = this.constructor.name;
  }
}
